import React from 'react';
import { createIcon } from '@chakra-ui/react';

export const SignIcon = createIcon({
	viewBox: '0 0 24 24',
	path: (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.6.999219c0-.441828-.3582-.8-.8-.8s-.8.358172-.8.8V3.19922c0 .44183.3582.8.8.8s.8-.35817.8-.8V.999219Zm0 11.499981c0-.4418-.3582-.8-.8-.8s-.8.3582-.8.8V22.999c0 .4419.3582.8.8.8s.8-.3581.8-.8V12.4992Z"
				fill="currentColor"
			/>
			<path
				d="m18.903 3.96406 3.2542 4.15-3.2542 4.15004H1.8V3.96406h17.103Zm-.1417 8.48064c.0001-.0001.0002-.0002.0003-.0004l-.0003.0004.3989.3127-.3989-.3127Z"
				stroke="currentColor"
				strokeWidth="1.6"
				fill="none"
			/>
		</>
	),
});
